import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-speedy-qty',
  templateUrl: './speedy-qty.component.html',
  styleUrls: ['./speedy-qty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, FormsModule],
})
export class SpeedyQtyComponent {
  @Input() qty = 1;

  @Input() fullWidth = false;

  @Output() qtyChange = new EventEmitter<number>();

  increment(): void {
    this.qty++;
    this.onQtyChange();
  }

  decrement(): void {
    if (this.qty > 1) {
      this.qty--;
      this.onQtyChange();
    }
  }

  onQtyChange(): void {
    this.qtyChange.emit(this.qty);
  }
}
